import React from 'react'
import { Helmet } from 'react-helmet-async';

import ServiceCTR from '../containers/services/ServiceCTR'

function Services() {
    return (
        <>
            {/* <Helmet>
                <title>Our Services | Bonvoy Tourism Dubai Tours & Experiences</title>
                <meta
                    name="description"
                    content="Explore Bonvoy Tourism's premium Dubai services including desert safari, city tours, dhow cruises, quad biking, yacht rental & customized tour packages."
                />
                <link rel="canonical" href="https://bonvoytourism.com/services" />
            </Helmet> */}
            <Helmet>
                <title>Dubai Tour Services – Desert Safaris, City Tours, Dhow Cruises & More | Bonvoy Tourism</title>
                <meta
                    name="description"
                    content="Explore all Bonvoy Tourism services in Dubai: desert safaris, city tours, dhow cruises, ATV quad biking, dune buggy rides, UAE day trips & private group tours. 5★ rated · Hotel pickup included · Book now."
                />
                <link rel="canonical" href="https://bonvoytourism.com/services" />

                <meta property="og:title" content="Dubai Tour Services – Desert Safaris, City Tours, Dhow Cruises & More | Bonvoy Tourism" />
                <meta property="og:description" content="6 categories of Dubai tour services: desert safaris, city tours, dhow cruises, ATV adventures & UAE day trips. 5★ TripAdvisor rated. Hotel pickup included." />
                <meta property="og:url" content="https://bonvoytourism.com/services" />
                <meta property="og:image" content="https://bonvoytourism.com/images/destination/destination3.webp" />
            </Helmet>
            <ServiceCTR />
        </>
    )
}

export default Services
